module.exports = __webpack_public_path__ + "static/big-115f1db72ca896a2be7aa5608924a5a0.png";